"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BBBLogo = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '240' : _b;
    return (react_1.default.createElement("a", { href: "https://www.bbb.org/us/ny/new-york/profile/caregiver-resources/hank-0121-87145117/#sealclick", target: "_blank", rel: "noopener noreferrer" },
        react_1.default.createElement("img", { alt: "Better business bureau logo", src: "https://storage.googleapis.com/hank-site-assets/images/bbb-accredited-logo.png", width: width })));
};
exports.default = BBBLogo;
//# sourceMappingURL=BBBLogo.js.map